/**
 * API Configuration
 * Automatically switches between development and production URLs
 * These values are replaced at build time by Vite
 */

declare const __API_BASE_URL__: string;
declare const __FRONTEND_URL__: string;

export const API_BASE_URL = __API_BASE_URL__;
export const FRONTEND_URL = __FRONTEND_URL__ || window.location.origin;

// Helper function for making API requests
export async function apiRequest(endpoint: string, options: RequestInit = {}) {
  const url = `${API_BASE_URL}${endpoint}`;

  const defaultOptions: RequestInit = {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  };

  const response = await fetch(url, { ...defaultOptions, ...options });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'An error occurred' }));
    throw new Error(error.message || `HTTP ${response.status}: ${response.statusText}`);
  }

  return response.json();
}
